import { createReducer, on } from '@ngrx/store';
import { LogIn, LogInFailure, LogInSuccess, LogOut, SetAuth, UpdateData, ResetStore } from '../actions/auth.actions';


export interface State {
    autenticado: boolean;
    seguridad: any | null;
    error: string | null;
}

export const initialState: State = {
    autenticado: false,
    seguridad: null,
    error: null
};

const _authReducer = createReducer(
    initialState,
    on(LogIn, (state) => state),
    on(LogInSuccess, (state, payload) => ({
        ...state,
        autenticado: true,
        seguridad: payload.seguridad,
        error: null
    })),
    on(LogInFailure, (state, payload) => ({
        ...state,
        error: payload.error
    })),
    on(LogOut, (state) => initialState),
    on(SetAuth, (state, payload) => ({
        ...state,
        autenticado: true,
        seguridad: payload.seguridad,
        error: null
    })),
    on(UpdateData, (state, payload) => (
        {
            ...state,
            seguridad: payload.seguridad,
            error: null
        }
    )),
    on(ResetStore, () => initialState)
);

export function authReducer(state, action) {
    return _authReducer(state, action);
}
